import { TipoGrupoEleitoresEnumType } from '../types/enums/TipoGrupoEleitoresEnumType';

const API_URL = `${process.env.REACT_APP_API_URL}`;
const API_SUBPATH = process.env.REACT_APP_API_SUBPATH;

function isValidIntegerToApi(value: string) {
  let number = +value;
  return Number.isInteger(number) && number >= 0 && number <= 2147483647;
}

const ApiHelper = {
  ARQUIVO: `${API_URL}${API_SUBPATH ? '/comum' : ''}/arquivo`,
  COMUM: `${API_URL}${API_SUBPATH ? '/sigaa' : ''}/comum`,
  ENSINO: `${API_URL}${API_SUBPATH ? '/sigaa' : ''}/ensino`,
  SCE: `${API_URL}/sce`,
  getUrl: {
    apiArquivo: {
      upload: () => `${ApiHelper.ARQUIVO}/publico/upload`,
    },
    apiComum: {
      unidades: (): string => `${ApiHelper.COMUM}/publico/unidades`,
    },
    apiEnsino: {
      cursos: (): string => `${ApiHelper.ENSINO}/publico/cursos`,
    },
    apiSCE: {
      buscaEleitores: (tipo: TipoGrupoEleitoresEnumType): string => `${ApiHelper.SCE}/eleitores?tipo=${tipo.key}`,
      candidatura: (idEleicao: number, idCargo: number, idCandidatura: number): string =>
        `${ApiHelper.SCE}/eleicoes/${idEleicao}/cargos/${idCargo}/candidaturas/${idCandidatura}`,
      candidaturas: (idEleicao: number, idCargo: number): string =>
        `${ApiHelper.SCE}/eleicoes/${idEleicao}/cargos/${idCargo}/candidaturas`,
      cargo: (idEleicao: number, idCargo: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/cargos/${idCargo}`,
      cargos: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/cargos`,
      despublicarEleicao: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/despublicar`,
      eleicao: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}`,
      eleicoes: (): string => `${ApiHelper.SCE}/eleicoes`,
      eleitores: (idEleicao: number, idGrupoEleitores: number, tipo?: TipoGrupoEleitoresEnumType): string =>
        `${ApiHelper.SCE}/eleicoes/${idEleicao}/grupos-eleitores/${idGrupoEleitores}/eleitores${
          tipo ? '?tipo=' + tipo.key : ''
        }`,
      grupoEleitores: (idEleicao: number, idGrupoEleitores: number): string =>
        `${ApiHelper.SCE}/eleicoes/${idEleicao}/grupos-eleitores/${idGrupoEleitores}`,
      gruposEleitores: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/grupos-eleitores`,
      membroComissao: (idEleicao: number, idMembro: number): string =>
        `${ApiHelper.SCE}/eleicoes/${idEleicao}/membros/${idMembro}`,
      membrosComissao: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/membros`,
      publicarEleicao: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/publicar`,
      relatorioEleitores: (idEleicao: number): string => `${ApiHelper.SCE}/eleicoes/${idEleicao}/eleitores`,
      token: (): string => `${ApiHelper.SCE}/token`,
    },
  },
  isValidIntegerToApi,
};

export default ApiHelper;
